import { render, staticRenderFns } from "./OffBlock.vue?vue&type=template&id=769d3f1a&scoped=true&"
import script from "./OffBlock.vue?vue&type=script&lang=js&"
export * from "./OffBlock.vue?vue&type=script&lang=js&"
import style0 from "./OffBlock.vue?vue&type=style&index=0&id=769d3f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769d3f1a",
  null
  
)

export default component.exports